import React, { Fragment, useEffect } from 'react';

//Components
import SSN from '@common-components/form/ssn/ssn';
import { SimpleDate } from '@common-components/form/date/simpleDateField';


//Constants
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';


export const RenderSearchBySSNComponents = ({ values, handleChange, handleBlur, isDocumentTypeSSN }) => {

    useEffect(() => {
        handleChange({ target: { name: 'dob', value: values.dob || values.dob_name } });
    }, []);


    return(
        <Fragment>
            <div className="grid-row grid-gap-lg margin-t-10">

                <SSN
                    label={{
                        labelText:'selfDesignation.search.radio-label.ssn',
                        labelClasses: ['gi-ssn__label--col', 'grid-col-12' ],
                    }}
                    inputData={{
                        id: 'ssn',
                        name: 'ssn',
                        inputClasses: ['grid-col-9 margin-t-5'],
                        type: INPUT_TYPES.TEXT,
                        placeholder: 'XXX-XX-XXXX',
                        value: isDocumentTypeSSN ? values.documentNumber : values.ssn,
                        readOnly: isDocumentTypeSSN,
                        isInputRequired: true
                    }}
                    actions={{
                        handleFieldChange: handleChange,
                        handleFieldBlur: handleBlur
                    }}
                    legend={{
                        helperClasses: ['grid-row','grid-col-6'],
                        isLegendRequired: true
                    }}
                />
                <SimpleDate
                    label={{
                        labelText:'label.dob',
                        labelClasses: ['gi-ssn__label--col', 'grid-col-12', 'margin-t-10-ve'],
                        wrapperClasses: ['grid-row','grid-col-6'],
                        isRequired: true
                    }}
                    input={{
                        id: 'dob_ssn',
                        name: 'dob',
                        inputClasses: ['grid-col-9', 'margin-t-20-ve'],
                        type: INPUT_TYPES.TEXT,
                        format:'##/##/####',
                        placeholder:'MM/DD/YYYY',
                        value: values.dob,
                        readOnly: true,
                        maxLength: 60,
                        isInputRequired: true
                    }}
                    actions={{
                        handleFieldChange: handleChange,
                        handleFieldBlur: handleBlur
                    }}
                />
            </div>
        </Fragment>
    );
};